var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157343"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2125",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0022 10.0078C10.8978 10.0078 10.0078 10.9038 10.0078 12.009C10.0078 13.1088 10.9085 14.0155 12.0076 14.0101C13.1013 14.0101 14.0128 13.0981 14.0074 12.0036C14.002 10.9091 13.1013 10.0078 12.0022 10.0078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9344 9.14927C17.854 8.07626 17.4037 7.18567 16.4708 6.58479C15.8971 6.21997 15.2591 6.08048 14.5889 6.04292C14.3959 6.03219 14.2029 6.0161 14.0099 6C12.6749 6 11.3399 6 9.99959 6C9.68327 6.02683 9.36159 6.04292 9.04527 6.07511C7.38324 6.25216 6.25199 7.38417 6.07506 9.0527C6.04289 9.36923 6.02145 9.69113 6 10.0077C6 11.3436 6 12.6794 6 14.0207C6.03753 14.4123 6.04825 14.8094 6.11259 15.1903C6.39138 16.7944 7.51191 17.8513 9.14177 17.9372C10.5679 18.0123 11.994 18.0015 13.4255 17.9962C14.0314 17.9962 14.6479 17.9855 15.2377 17.8835C16.8086 17.6153 17.8326 16.4725 17.9291 14.8684C17.9988 13.731 17.9934 12.5882 17.9988 11.4455C18.0041 10.6837 17.9934 9.9111 17.9344 9.14927ZM12.0101 15.0991C10.3106 15.1044 8.92195 13.7203 8.92195 12.0142C8.92195 10.3027 10.2891 8.92393 11.9994 8.92393C13.7043 8.92393 15.0875 10.2974 15.0929 12.0035C15.0929 13.7042 13.7097 15.0937 12.0101 15.0991ZM15.2162 9.52482C14.8141 9.53018 14.4871 9.20828 14.4871 8.8059C14.4871 8.40889 14.7927 8.09236 15.1894 8.08163C15.5969 8.0709 15.9239 8.38743 15.9293 8.78981C15.94 9.18682 15.6183 9.51945 15.2162 9.52482Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.8f0c939ffdebf6c785d28ff66ec0e1bd.svg";
export { ForwardRef as ReactComponent };